import React, { useEffect } from 'react'
import './branch-area.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import CheckboxInput from '../../common/inputs/CheckboxInput'
import { useState } from 'react'
import { customerAxios } from '../../../config/axios'
import { IoClose } from "react-icons/io5";
import { toast } from 'react-hot-toast'
import { BiLoaderAlt } from 'react-icons/bi'

const CUPostOffice = ({ currentData, setData, setModal }) => {
    const [form, setForm] = useState({
        city: currentData?.city_name || '',
        pin_code: currentData?.pin_codes || [],
        post_offices: currentData?.post_offices || [],
        service: currentData?.service || false,
        installation: currentData?.installation || false
    })
    const [pinInput, setPinInput] = useState('')
    const [postInput, setPostInput] = useState('')
    const [loading, setLoading] = useState('')


    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleAddPinToList = () => {
        if (!pinInput || pinInput.length !== 6) {
            return toast.error('Enter valid pin code');
        }

        if (form?.pin_code?.includes(pinInput)) {
            return toast.error('Already listed');
        }

        setForm({
            ...form,
            pin_code: [...(form?.pin_code || []), pinInput]
        })

        setPinInput('')
    }
    const handleAddPostToList = () => {
        if (!postInput) {
            return toast.error('Enter valid post office');
        }

        if (form?.post_offices?.includes(postInput)) {
            return toast.error('Already listed');
        }

        setForm({
            ...form,
            post_offices: [...(form?.post_offices || []), postInput]
        })

        setPostInput('')
    }

    const handleRemovePinCode = (pin) => {
        setForm({
            ...form,
            pin_code: form?.pin_code?.filter((value) => value !== pin)
        })
    }

    const handleRemovePostOffice = (post) => {
        setForm({
            ...form,
            post_offices: form?.post_offices?.filter((value) => value !== post)
        })
    }

    const handleRadioSelect = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.checked
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading('submit')
        if (currentData) {
            // Update current area
            customerAxios.put('/l/area', { ...form, city_id: currentData?.city_id, }).then((response) => {
                setData((state) => state?.map((area) => {
                    if (area.city_id === currentData.city_id) {
                        return {
                            ...area,
                            city_name: form?.city,
                            post_offices: form?.post_offices,
                            pin_codes: form?.pin_code,
                            service: form?.service,
                            installation: form?.installation,
                        }
                    }
                    return area
                }))
                setLoading('')
                setModal({ status: false })
            }).catch((error) => {
                setLoading('')
                toast.error(error.message)
            })
        } else {
            // Create new area
            customerAxios.post('/l/area', form).then((response) => {
                setData((state) => [response.data, ...state])
                setLoading('')
                setModal({ status: false })
            }).catch((error) => {
                setLoading('')
                toast.error(error.message)
            })
        }

    }

    useEffect(() => {

        if (currentData) {
            setForm({
                ...form,
                city: currentData?.city_name || '',
                pin_code: currentData?.pin_codes || [],
                service: currentData?.service || false,
                installation: currentData?.installation || false
            })
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className="add-post-office-comp-div">
            <p className='title'>Default State : India/Kerala</p>
            <form action="" onSubmit={handleSubmit}>
                <NormalInput label='City*' name='city' value={form?.city} onChangeFun={handleChange} />
                <div className='pin-code-div'>
                    {form?.post_offices?.[0] && <div className="list-div">
                        {form?.post_offices?.map((post) => <div key={post}><span>{post}</span>
                            <span onClick={() => handleRemovePostOffice(post)}><IoClose /></span></div>)}
                    </div>}
                    <div className='action-div'>
                        <NormalInput label={form?.city ? `Post office under ${form?.city}` : 'Post office'} name='post_offices' value={postInput}
                            type={'text'} onChangeFun={(e) => setPostInput(e.target.value)} isRequired={false} />
                        <button type='button' onClick={handleAddPostToList}>Add to list</button>
                    </div>
                </div>
                <div className='pin-code-div'>
                    {form?.pin_code?.[0] && <div className="list-div">
                        {form?.pin_code?.map((code) => <div key={code}><span>{code}</span>
                            <span onClick={() => handleRemovePinCode(code)}><IoClose /></span></div>)}
                    </div>}
                    <div className='action-div'>
                        <NormalInput label={form?.city ? `Pin code under ${form?.city}` : 'Pin code'} name='pin_code' value={pinInput}
                            type={'number'} onChangeFun={(e) => setPinInput(e.target.value)} isRequired={false} />
                        <button type='button' onClick={handleAddPinToList}>Add to list</button>
                    </div>
                </div>
                <div className="radio-input-group-div">
                    <CheckboxInput label={'Service Area'} value={'service'} name={'service'} isRequired={false}
                        checked={form?.service === true} onChangeFun={handleRadioSelect} />
                    <CheckboxInput label={'Installation Area'} value={'installation'} name={'installation'} isRequired={false}
                        checked={form?.installation === true} onChangeFun={handleRadioSelect} />
                </div>
                <button type='submit' style={{ marginTop: "15px" }}>
                    {loading === 'submit'
                        ? <span className='loading-icon'><BiLoaderAlt /></span>
                        : "Submit"
                    }
                </button>
            </form>
        </div>
    )
}

export default CUPostOffice